import { render } from "./Statement.vue?vue&type=template&id=353c86bf&scoped=true"
import script from "./Statement.vue?vue&type=script&lang=js"
export * from "./Statement.vue?vue&type=script&lang=js"

import "./Statement.vue?vue&type=style&index=0&id=353c86bf&lang=scss&scoped=true"

import exportComponent from "/Users/jevons/Documents/Vue/activity_drawform/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.17_vue@3.5.17_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-353c86bf"]])

export default __exports__